<template>
    <div class="container">
        <div class="balance-block">
            <div class="label-text">
                баланс
            </div>
            <div class="balance-text">
                {{ store.studentBalance.toFixed(2).toLocaleString() }} <span class="text-[16px]">грн</span>
            </div>
        </div>
        <div class="active-to-block">
            <div class="label-text">
                активний до
            </div>
            <!-- <div class="date-text mr-[15px]">
                {{ activeToDate }} 
            </div> -->

            <div v-if="activeToDate == 'борг'" class="font-normal text-[22px] mt-[-6px] text-center text-[#F10265]">
                заборгованість
            </div>
            <div v-else class="date-text mr-[15px]">
                <b>{{ activeToDate }}</b>
            </div>
        </div>
    </div>
</template>

<script>
    import { useMainStore } from '../../store/mainStore'
    import { ref, onBeforeMount, watch } from 'vue'

    export default {
        name: 'StudentFinanceData',

        setup() {
            const store = useMainStore()

            const activeToDate = ref('')

            const currentDate = new Date()

            const mountValue = currentDate.getMonth() > 9 ? currentDate.getMonth() : `0${currentDate.getMonth()}`
            const mountValue2 = currentDate.getMonth() + 2 > 9 ? currentDate.getMonth() + 2 : `0${currentDate.getMonth() + 2}`

            if (store.studentBalance >= 0) {
                const currentDate = new Date()
                activeToDate.value = `01.${mountValue2}.${currentDate.getFullYear()}`
            } else {
                activeToDate.value = 'борг'
            }

            // if (store.studentBalance >= 0) {
            //     const currentDate = new Date()
            //     const date = new Date(`${currentDate.getMonth() + 2}.01.${currentDate.getFullYear()}`)
            //     console.log('date month', date.getMonth())
            //     activeToDate.value = date.toLocaleDateString().split('T')[0].split('-').reverse().join('.')
            // } else {
            //     const currentDate = new Date()
            //     const date = new Date(`${currentDate.getMonth()}.01.${currentDate.getFullYear()}`)
            //     console.log('date month', date.getMonth())
            //     activeToDate.value = date.toLocaleDateString().split('T')[0].split('-').reverse().join('.')
            // }

            return {
                store,
                activeToDate
            }
        }
    }
</script>

<style lang="scss" scoped>


    @media (min-width: 0px) and (max-width: 1800px) {
        .container {
            @apply flex justify-between;
        }

        .balance-block {
            @apply rounded-[10px] px-[8px] mr-[18px] w-[218px] h-[56px];
        }

        .active-to-block {
            @apply relative rounded-[10px] px-[8px] w-[225px] h-[56px];
        }
        
        .label-text {
            @apply text-[#FFF] mt-[5px] mb-[2px] text-[14px];
        }

        .balance-text {
            @apply font-bold text-[28px] mt-[-10px] text-center text-[#FFF];
        }

        .date-text {
            @apply font-bold text-[28px] mt-[-10px] text-end text-[#FFF];
        }
    }

    @media (min-width: 1800px) and (max-width: 8000px) {
        .container {
            @apply flex justify-between h-[58px] w-[582px];
        }

        .balance-block {
            @apply rounded-[10px] px-[8px] mr-[18px] w-[228px] h-[56px];
        }

        .active-to-block {
            @apply relative rounded-[10px] px-[8px] w-[225px] h-[56px];
        }
        
        .label-text {
            @apply text-[#FFF] mt-[3px] mb-[2px] text-[14px];
        }

        .balance-text {
            @apply font-bold text-[28px] mt-[-10px] text-center text-[#FFF];
        }

        .date-text {
            @apply font-bold text-[28px] mt-[-10px] text-end text-[#FFF];
        }
    }

</style>
